import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";
import productData from "../Datas/productData";
import { FaHeart, FaCheckCircle, FaPlay } from "react-icons/fa";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <Header />

      <main>
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-content">
            <div className="hero-logo-circle">
              <span className="play-text">play</span>
            </div>
            <h1 className="hero-title">
              We Take Play
              <br />
              Seriously
            </h1>
            <p className="hero-subtitle">
              Toys made to tug, toss and totally
              <br />
              obsess over
            </p>
            <Link to="/shop" className="btn-shop-orange" onClick={toTop}>
              Shop Dog Toys
            </Link>
          </div>
          <div className="slider-dots">
            <span className="dot"></span>
            <span className="dot active"></span>
            <span className="dot"></span>
          </div>
        </section>

        {/* Best Sellers Section */}
        <section className="best-sellers-section">
          <div className="best-sellers-header">
            <h2 className="section-title">Our Best Sellers</h2>
            <p className="section-subtitle">
              Tried, tested, and loved by pets everywhere.
            </p>
          </div>

          <div className="category-cards-container">
            {/* Card 1 */}
            <div className="category-card card-zoomie">
              <img
                src="/main/main2-1.webp"
                alt="Dog running with ball"
                className="card-image"
              />
              <Link
                to="/category/zoomierex"
                className="btn-shop-green"
                onClick={toTop}
              >
                Shop ZoomieRex
              </Link>
            </div>

            {/* Card 2 */}
            <div className="category-card card-chill">
              <img
                src="/main/main2-2.jpg"
                alt="Dog resting on bed"
                className="card-image"
              />
              <Link
                to="/category/chill-pads"
                className="btn-shop-green"
                onClick={toTop}
              >
                Shop Chill Pads
              </Link>
            </div>

            {/* Card 3 */}
            <div className="category-card card-cat">
              <img
                src="/main/main2-3.jpg"
                alt="Cat playing with donut toy"
                className="card-image"
              />
              <Link
                to="/category/cat-toys"
                className="btn-shop-green"
                onClick={toTop}
              >
                Shop Cat Toys
              </Link>
            </div>

            {/* Card 4 */}
            <div className="category-card card-plush">
              <img
                src="/main/main2-4.webp"
                alt="Dog holding plush toy"
                className="card-image"
              />
              <Link
                to="/category/dog-plush"
                className="btn-shop-green"
                onClick={toTop}
              >
                Shop Dog Plush
              </Link>
            </div>
          </div>
        </section>

        {/* Trending Products Section */}
        <section className="trending-products-section">
          <div className="trending-header">
            <h2 className="section-title">Trending Products</h2>
            <p className="section-subtitle">
              Curated for you and your furry friend.
            </p>
          </div>

          <div className="trending-grid">
            {productData.slice(0, 4).map((product) => (
              <div key={product.id} className="trending-card">
                <div className="trending-image-wrapper">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="trending-image"
                  />
                </div>
                <div className="trending-info">
                  <h3 className="trending-name">{product.name}</h3>
                  <div className="trending-price-container">
                    {product.oldPrice && (
                      <span className="old-price">
                        ${Number(product.oldPrice).toFixed(2)}
                      </span>
                    )}
                    <span className="current-price">
                      ${Number(product.price).toFixed(2)}
                    </span>
                  </div>
                  <Link
                    to={`/product/${product.id}`}
                    className="btn-shop-now"
                    onClick={toTop}
                  >
                    Shop Now
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Trust Section */}
        <section className="trust-section">
          <div className="trust-text-container">
            <h2 className="trust-title">
              Pets Love Us. People
              <br />
              Trust Us.
            </h2>
            <p className="trust-description">
              Since 2010, we've created pet products rooted in care, quality and
              thoughtful design. Inspired by our pug, Momo, our family of brands
              delivers toys, beds, cat essentials and outdoor gear made with
              high-quality materials and ethical manufacturing practices. With
              our refreshed look, we're proud to introduce Play, Feline Frenzy,
              Scout and About and LeftPine, built on the same comfort,
              durability and trust pet parents rely on.
            </p>
            <Link to="/about" className="btn-learn-more" onClick={toTop}>
              Learn More
            </Link>
          </div>
          <div className="trust-image-container">
            <img
              src="/main/main3.webp"
              alt="Happy Pug on yellow chair"
              className="trust-image"
            />
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section">
          <div className="testimonials-header">
            <h2 className="section-title">Take it from our customers</h2>
            <p className="section-subtitle">
              Tried, tested, and loved by pets everywhere.
            </p>
          </div>

          <div className="testimonials-grid">
            {/* Testimonial 1 */}
            <div className="testimonial-card">
              <img
                src="/main/main4-1.avif"
                alt="Golden Retriever with Party Animal toy"
                className="testimonial-img"
              />
              <div className="testimonial-content">
                <div className="hearts">
                  <FaHeart />
                  <FaHeart />
                  <FaHeart />
                  <FaHeart />
                  <FaHeart />
                </div>
                <div className="author">
                  Cindy <FaCheckCircle className="verified-icon" />
                </div>
                <h4 className="review-title">Party animal</h4>
                <p className="review-text">
                  Sabine, my golden retriever, loves to play tug war with this!!
                  <br />I call her a party animal!!
                </p>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="testimonial-card">
              <img
                src="/main/main4-2.avif"
                alt="Belgian Malinois with Safari toys"
                className="testimonial-img"
              />
              <div className="testimonial-content">
                <div className="hearts">
                  <FaHeart />
                  <FaHeart />
                  <FaHeart />
                  <FaHeart />
                  <FaHeart />
                </div>
                <div className="author">
                  Mike Veale <FaCheckCircle className="verified-icon" />
                </div>
                <h4 className="review-title">My dog's favorite toys!</h4>
                <p className="review-text">
                  Odin, a GCF K9, received his Big 5 of Africa collection about
                  5 months ago and it is his absolute favorite set of toys. Odin
                  is a Belgian..
                </p>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="testimonial-card">
              <img
                src="/main/main4-3.avif"
                alt="Dog with breakfast food toys"
                className="testimonial-img"
              />
              <div className="testimonial-content">
                <div className="hearts">
                  <FaHeart />
                  <FaHeart />
                  <FaHeart />
                  <FaHeart />
                  <FaHeart />
                </div>
                <div className="author">
                  K <FaCheckCircle className="verified-icon" />
                </div>
                <h4 className="review-title">
                  One of the best toy collections!
                </h4>
                <p className="review-text">
                  Absolutely adore this IHOP play toy set—my pup loves it! It's
                  well-made, durable, and definitely worth every "bite"! 🙃
                </p>
              </div>
            </div>
          </div>

          <div className="store-review-summary">
            <h3 className="summary-title">
              What customers think about the store
            </h3>
            <p className="summary-text">
              This store offers high-quality, durable pet toys and beds with
              creative designs. Customers praise excellent craftsmanship,
              machine-washable materials, and eco-friendly practices. Products
              feature interactive elements like squeakers, crinkles, and hidden
              compartments. Strong customer service resolves issues promptly.
              Items hold up well even with aggressive chewers.
            </p>
          </div>
        </section>

        {/* Sleep Section */}
        <section className="sleep-section">
          <div className="sleep-container">
            <div className="sleep-image-half">
              <img
                src="/main/main5.webp"
                alt="Dog resting in comfortable bed"
                className="sleep-image"
              />
            </div>
            <div className="sleep-text-half">
              <h2 className="sleep-title">
                Where Great Play
                <br />
                Ends in Great Sleep
              </h2>
              <p className="sleep-subtitle">
                Durable, washable beds for everyday lounging
              </p>
              <Link
                to="/category/beds"
                className="btn-shop-beds"
                onClick={toTop}
              >
                Shop Dog Beds
              </Link>
            </div>
          </div>
        </section>

        {/* Shop by Brand Section */}
        <section className="brands-section">
          <h2 className="section-title text-center">Shop by Brand</h2>

          <div className="brands-grid">
            <Link to="/brand/play" className="brand-card" onClick={toTop}>
              <img
                src="/main/main6-1.jpg"
                alt="Play Brand"
                className="brand-bg-image"
              />
              <div className="brand-logo-container">
                <img
                  src="/main/main6-1-logo.png"
                  alt="Play Logo"
                  className="brand-logo"
                  onError={(e) => (e.target.style.display = "none")}
                />
                {/* Fallback text if no logo image */}
                <div className="brand-fallback-logo play-logo">
                  <span className="play-text">play</span>
                </div>
              </div>
            </Link>

            <Link
              to="/brand/feline-frenzy"
              className="brand-card"
              onClick={toTop}
            >
              <img
                src="/main/main6-2.jpg"
                alt="Feline Frenzy Brand"
                className="brand-bg-image"
              />
              <div className="brand-logo-container">
                <div className="brand-fallback-logo feline-frenzy-logo">
                  <span className="line1">feline</span>
                  <span className="line2">frenzy</span>
                </div>
              </div>
            </Link>

            <Link
              to="/brand/scout-and-about"
              className="brand-card"
              onClick={toTop}
            >
              <img
                src="/main/main6-3.jpg"
                alt="Scout and About Brand"
                className="brand-bg-image"
              />
              <div className="brand-logo-container">
                <div className="brand-fallback-logo scout-logo">
                  <span className="line1">SCOUT</span>
                  <span className="line2">and</span>
                  <span className="line3">ABOUT</span>
                </div>
              </div>
            </Link>

            <Link to="/brand/left-pine" className="brand-card" onClick={toTop}>
              <img
                src="/main/main6-4.webp"
                alt="Left Pine Brand"
                className="brand-bg-image"
              />
              <div className="brand-logo-container">
                <div className="brand-fallback-logo leftpine-logo">
                  <span>left</span>
                  <span className="pine-tree">🌲</span>
                  <span>pine</span>
                </div>
              </div>
            </Link>
          </div>
        </section>
        {/* Meet the Wobble Ball Section */}
        <section className="wobble-section">
          <div className="wobble-text-container">
            <h2 className="wobble-title">
              Meet the Wobble
              <br />
              Ball
            </h2>
            <p className="wobble-subtitle">
              Thoughtfully designed to wobble, roll and reward play.
            </p>
            <Link
              to="/product/wobble-ball"
              className="btn-see-action"
              onClick={toTop}
            >
              See It in Action
            </Link>
          </div>
          <div className="wobble-video-container">
            <img
              src="/main/main7.webp"
              alt="Dog playing with wobble ball"
              className="wobble-image"
            />
            <button className="play-button" aria-label="Play video">
              <FaPlay className="play-icon" />
            </button>
          </div>
        </section>

        {/* Z is for Zoomies Section */}
        <section className="zoomies-section">
          <div className="zoomies-container">
            <div className="zoomies-image-half">
              <img
                src="/main/main8.webp"
                alt="Dog carrying Z shaped toy"
                className="zoomies-image"
              />
            </div>
            <div className="zoomies-text-half">
              <h2 className="zoomies-title">Z is for Zoomies!</h2>
              <p className="zoomies-subtitle">
                The new ZoomieRex SuperZag toy that chases,
                <br />
                bounces, and holds treats. Playtime just got an
                <br />
                upgrade.
              </p>
              <Link
                to="/category/zoomierex"
                className="btn-shop-zoomies"
                onClick={toTop}
              >
                Shop ZoomieRex
              </Link>
            </div>
          </div>
        </section>

        {/* Follow Us on Socials Section */}
        <section className="socials-section">
          <h2 className="section-title text-center">Follow Us on Socials</h2>

          <div className="socials-slider-container">
            <div className="socials-grid">
              <div className="social-card">
                <img
                  src="/main/a1.webp"
                  alt="Social media post 1"
                  className="social-img"
                />
              </div>
              <div className="social-card">
                <img
                  src="/main/a2.webp"
                  alt="Social media post 2"
                  className="social-img"
                />
              </div>
              <div className="social-card">
                <img
                  src="/main/main2-1.webp"
                  alt="Social media post 3"
                  className="social-img"
                />
              </div>
              <div className="social-card">
                <img
                  src="/main/main2-2.jpg"
                  alt="Social media post 4"
                  className="social-img"
                />
              </div>
              <div className="social-card">
                <img
                  src="/main/main2-3.jpg"
                  alt="Social media post 5"
                  className="social-img"
                />
              </div>
              <div className="social-card">
                <img
                  src="/main/main2-4.webp"
                  alt="Social media post 6"
                  className="social-img"
                />
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
